import { Injectable, Inject } from '@angular/core';
import { PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { fromEvent } from 'rxjs/observable/fromEvent';
var MinimalStorage = /** @class */ (function () {
    function MinimalStorage(key$, val) {
        localStorage.setItem(key$, JSON.stringify(val));
    }
    return MinimalStorage;
}());
export { MinimalStorage };
var MinimalLS = /** @class */ (function () {
    function MinimalLS(platformId) {
        var _this = this;
        this.platformId = platformId;
        this.itemsSubject = new Map();
        this._prefix = '*ls*';
        this.storage = new Subject();
        if (isPlatformBrowser(this.platformId)) {
            this.storageEvent = fromEvent(window, 'storage');
            this.storageEvent.subscribe(function (e) {
                _this.storage.next({
                    key: e.key,
                    value: e.newValue
                });
            });
            this.storageObservable = this.storage.asObservable();
        }
    }
    /**
     * get boolean
     */
    /**
       * get boolean
       */
    MinimalLS.prototype.hasItem = /**
       * get boolean
       */
    function (key$) {
        var key = this._addPrefix(key$);
        if (isPlatformBrowser(this.platformId)) {
            return !!localStorage.getItem(key);
        }
        if (isPlatformServer(this.platformId)) {
            return false;
        }
    };
    /**
     * Set new item or replace item
     */
    /**
       * Set new item or replace item
       */
    MinimalLS.prototype.setItem = /**
       * Set new item or replace item
       */
    function (key$, val, _storage) {
        if (_storage === void 0) { _storage = true; }
        var key = this._addPrefix(key$);
        if (_storage) {
            if (isPlatformBrowser(this.platformId)) {
                // tslint:disable-next-line:no-unused-expression
                new MinimalStorage(key, val);
            }
        }
        this.storage.next({
            key: key,
            value: this.item(key$)
        });
        // this.itemsSubject.set(key, new BehaviorSubject<string>(val));
    };
    /**
     * Get Observable from localStorage
     */
    /**
       * Get Observable from localStorage
       */
    MinimalLS.prototype.getItem = /**
       * Get Observable from localStorage
       */
    function (key$, before) {
        var _this = this;
        var key = this._addPrefix(key$);
        var ob = new Observable(function (observer) {
            if (_this.hasItem(key$)) {
                observer.next(_this.item(key$));
            }
            _this.storageObservable.subscribe(function (e) {
                if (key === e.key) {
                    observer.next(e.value);
                }
            });
        });
        return ob;
    };
    /**
     * Get value from localstorage
     */
    /**
       * Get value from localstorage
       */
    MinimalLS.prototype.item = /**
       * Get value from localstorage
       */
    function (key$) {
        var key = this._addPrefix(key$);
        try {
            return JSON.parse(window.localStorage[key]);
        }
        catch (e) {
            return null;
        }
    };
    MinimalLS.prototype._addPrefix = function (val) {
        return "{\"" + this._prefix + "\":\"" + val + "\"}";
    };
    MinimalLS.prototype._removePrefix = function (val) {
        try {
            return JSON.parse(val)[this._prefix];
        }
        catch (e) {
            return null;
        }
    };
    MinimalLS.decorators = [
        { type: Injectable },
    ];
    /** @nocollapse */
    MinimalLS.ctorParameters = function () { return [
        { type: Object, decorators: [{ type: Inject, args: [PLATFORM_ID,] },] },
    ]; };
    return MinimalLS;
}());
export { MinimalLS };
//# sourceMappingURL=minimal-localstorage.js.map